import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ClipboardList, PackageCheck, Receipt, CreditCard, FileMinus2, Banknote,
} from 'lucide-react';
import WorkflowItem from './WorkflowItem';
import WorkflowConnector from './WorkflowConnector';

/**
 * VENDORS workflow panel: Purchase Orders → Receive Inventory →
 * Enter Supplier Bills → Pay Bills, with supplier-credit and funding
 * sub-actions beneath the main flow.
 */
export default function VendorWorkflow() {
  const navigate = useNavigate();
  return (
    <section className="wf-panel">
      <header className="wf-header">
        <span className="wf-header-title">Vendors</span>
      </header>
      <div className="wf-body">
        <div className="wf-flow">
          <WorkflowItem icon={ClipboardList} label="Purchase Orders" desc="Order stock & services" path="/purchase-orders" />
          <WorkflowConnector />
          <WorkflowItem icon={PackageCheck} label="Receive Inventory" desc="Receive against POs" path="/inventory" color="green" />
          <WorkflowConnector />
          <WorkflowItem icon={Receipt} label="Enter Supplier Bills" desc="Record vendor invoices" path="/bills/new" />
          <WorkflowConnector />
          <WorkflowItem icon={CreditCard} label="Pay Bills" desc="Settle vendor balances" path="/payments" emphasized />
        </div>
        <div className="wf-sub">
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payments')}>
            <FileMinus2 /> <strong>Supplier Credits</strong> / Bill Adjustments
          </button>
          <span className="wf-sub-sep" />
          <button type="button" className="wf-sub-item" onClick={() => navigate('/banking')}>
            <Banknote /> Funding / Payment Options
          </button>
        </div>
      </div>
    </section>
  );
}
